module.exports = __webpack_public_path__ + "static/media/history_10.ab11b610.jpg";